import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

function readStoredCustomer() {
  try {
    const raw = localStorage.getItem("dsite_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isCustomerSession(role, isCustomer) {
  if (isCustomer || role === "customer") return true;
  return localStorage.getItem("dsite_role") === "customer";
}

/**
 * 문의 양식용 고객 프로필 — auth 컨텍스트 + localStorage + /customer/me
 */
export function useCustomerContactProfile(active = true) {
  const { user, isCustomer, role, loading: authLoading } = useAuth();
  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(false);

  const customerSession = isCustomerSession(role, isCustomer);

  const loadProfile = useCallback(async () => {
    if (!customerSession || !localStorage.getItem("dsite_token")) {
      setProfile(null);
      return null;
    }

    const stored = readStoredCustomer();
    if (stored?.email) {
      setProfile(stored);
    } else if (user?.email && customerSession) {
      setProfile(user);
    }

    setProfileLoading(true);
    try {
      const res = await api.get("/customer/me");
      const me = res.data || {};
      const next = {
        id: me.id,
        email: me.email || "",
        name: me.name || "",
        phone: me.phone || "",
        company: me.company || "",
        role: "customer",
      };
      localStorage.setItem("dsite_user", JSON.stringify(next));
      setProfile(next);
      return next;
    } catch {
      return stored || (user?.email ? user : null);
    } finally {
      setProfileLoading(false);
    }
  }, [customerSession, user]);

  useEffect(() => {
    if (!active || authLoading) return undefined;
    if (!customerSession) {
      setProfile(null);
      return undefined;
    }
    loadProfile();
    return undefined;
  }, [active, authLoading, customerSession, loadProfile, user?.id]);

  return {
    profile: customerSession ? profile : null,
    loading: authLoading || profileLoading,
    reload: loadProfile,
  };
}
